import React, { useEffect } from 'react';
import cx from 'classnames';
import TimerText from 'components/timer-text/TimerText';
import { I18nNamespace } from 'constants/i18n.const';
import { usePageTimer } from 'hooks/usePageTimer';
import { useTranslation } from 'hooks/useTranslation';
import { QRCodeCanvas } from 'qrcode.react';
import './qr-transaction-image.css';
import Typography from 'components/typography/Typography';
import { TYPOGRAPHY_VARIANTS } from 'components/typography/typography-utils';
import PageActions from 'components/page-actions/PageActions';
import { useAppSelector } from 'store/store-hooks';
import CONFIG from 'config';
import { usePrintPhotoApiActionMutation } from 'store/api/print.slice-api';
import { isEqualVal } from 'helpers/string.helper';
import { FRAME_TO_PAYMENT_DIRECTLY } from 'constants/photo.const';
import { useQrTransactionImage } from './useQrTransactionImage';

const QrTransactionImage = () => {
  const { T, t } = useTranslation([I18nNamespace.COMMON, I18nNamespace.PAGE]);
  const { second } = usePageTimer({
    content: t('common:QRimageDownloadTimeup'),
  });
  const { handleNext } = useQrTransactionImage();
  const { transactionId, frameId, quantitySheet, layoutId } = useAppSelector(
    (state) => state.selfeApp,
  );
  const { boothInfo } = useAppSelector((state) => state.booth);
  const [printPhotoApiAction] = usePrintPhotoApiActionMutation();

  useEffect(() => {
    const printNumber = isEqualVal(FRAME_TO_PAYMENT_DIRECTLY, frameId)
      ? Math.max(quantitySheet / 2, 1)
      : quantitySheet;
    printPhotoApiAction({
      transactionId,
      numberOfImage: printNumber,
      layoutId,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderEditPhotoActions = () => (
    <PageActions
      NextButtonProps={{ children: t('page:complete') }}
      hidePrev={true}
      handleContinue={handleNext}
    />
  );
  return (
    <>
      <TimerText second={second} />
      <div className="flex justify-center flex-col items-center qr-transaction-image-container">
        <div className="my-32">
          <Typography
            variant={TYPOGRAPHY_VARIANTS.H1}
            className="qr-transaction-image-title"
          >
            {T('scanQRViewImage')}
          </Typography>
        </div>
        <div className="qr_transaction-image-wrapper">
          <QRCodeCanvas
            style={{ height: 'auto', maxWidth: '100%', width: '45rem' }}
            value={`${
              boothInfo?.DownloadUrl || CONFIG.REACT_APP_DOWNLOAD_IMAGE_URL
            }${transactionId}`}
          />
        </div>
      </div>
      {renderEditPhotoActions()}
    </>
  );
};

export default QrTransactionImage;
